function getApiBaseUrl() {

    // return 'http://192.168.88.69:5003/'; // Solo para red 192.168.88.x

  return 'https://api.grupodracena.com/'; // Solo para red 192.168.88.x

}

function getApiImagen() {
  return 'https://api.grupodracena.com'; // Solo para red 192.168.88.x
  // return 'http://192.168.88.69:5003'; // Solo para red 192.168.88.x
}

export { getApiBaseUrl, getApiImagen };

